export type FileDownloadOption = 'formatted_csv' | '_csv' | 'raw_csv' | 'formatted_xlsx' | '_xlsx' | 'files';

export const DEFAULT_FILE_DOWNLOAD_OPTION: FileDownloadOption = 'formatted_csv';

export const FILE_DOWNLOAD_OPTIONS: Array<{ title: string; value: FileDownloadOption }> = [
    {title: 'CSV with decimals rounded', value: 'formatted_csv'},
    {title: 'CSV with no rounding', value: '_csv'},
    {title: 'CSV with no rounding, linked as list', value: 'raw_csv'},
    {title: 'Excel with formatting ', value: 'formatted_xlsx'},
    {title: 'Excel with no formatting', value: '_xlsx'}
];
